import React from "react";
import PropTypes from "prop-types";
import { Carousel } from "react-responsive-carousel";
import { Segmant, StreetView } from "../../components";

const StreetCarousal = ({ lat, lng }) => {
  return (
    <div>
      <Segmant className="slider_segment">
        <>
          <Carousel
            showIndicators={false}
            infiniteloop={false}
            autoPlay={false}
            interval={2000}
            showThumbs={false}
          >
            <StreetView lat={lat} lang={lng} />
          </Carousel>
        </>
      </Segmant>
    </div>
  );
};

StreetCarousal.propTypes = {
  imageData: PropTypes.array.isRequired,
  button: PropTypes.bool,
};
export default StreetCarousal;
